export const PURCHASED_COMPONENTS_MATCH_CRITERIA = {
  COMPONENT_GEOMETRY: 'COMPONENT_GEOMETRY',
  PRODUCT_GEOMETRY: 'PRODUCT_GEOMETRY',
  PRODUCT_SKU: 'PRODUCT_SKU',
  PRODUCT_SKU_EQUIVALENT: 'PRODUCT_SKU_EQUIVALENT',
};

export const PRODUCT_MATCH_CRITERIA = {
  PRODUCT_GEOMETRY: 'PRODUCT_GEOMETRY',
  PRODUCT_SKU: 'PRODUCT_SKU',
  PRODUCT_SKU_EQUIVALENT: 'PRODUCT_SKU_EQUIVALENT',
};

export const TABS = {
  SMART_MATCHES: 0,
  SEARCH: 1,
};

export const MODES = {
  CHANGE: 'CHANGE',
  CONVERT: 'CONVERT',
  ADD: 'ADD',
};
